import {centerAxiosRequest} from "@/utils/axios";

const BOOKS_BASE_URL = '/books';

/**
 * 基础检索
 */
const searchSimple = function (query){
    return centerAxiosRequest({
        method: 'POST',
        url: `${BOOKS_BASE_URL}/search_simple`,
        data: query
    });
};

/**
 * 高级检索
 */


const search = function (query){
    return centerAxiosRequest({
        method: 'POST',
        url: `${BOOKS_BASE_URL}/search`,
        data: query
    });
};

/**
 * 批量获取图书封面
 */
const getCovers = function (isbns){
    return centerAxiosRequest({
        method: 'GET',
        url: `${BOOKS_BASE_URL}/extend/${encodeURIComponent(isbns)}?coversOnly=true`,
    });
};

/**
 * 首页-新书速递
 */
const getNewBookRecommend = function (query){
    return centerAxiosRequest({
        method: 'POST',
        url: `${BOOKS_BASE_URL}/newbookrecommend`,
        data: query
    });
};

/**
 * 首页-推荐图书
 */
const getRecommend = function (query){
    return centerAxiosRequest({
        method: 'POST',
        url: `${BOOKS_BASE_URL}/recommend`,
        data: query
    });
};

/**
 * 图书详情
 */
const getBookDetail = function (bookId){
    return centerAxiosRequest({
        method: 'GET',
        url: `${BOOKS_BASE_URL}/${bookId}/info`,
    });
};

/**
 * 获取书目分类中的二级分类
 */
const getClasses = function (id){
    return centerAxiosRequest({
        method: 'GET',
        url: `${BOOKS_BASE_URL}/${id}/classes`,
    });
};

/**
 * 获取书目分类列表数据
 */
const browse = function (clsNo, query){
    return centerAxiosRequest({
        method: 'POST',
        url: `${BOOKS_BASE_URL}/${clsNo}/browse`,
        data: query
    });
};

/**
 * 最新上架
 */
const getLatest = function (query){
    return centerAxiosRequest({
        method: 'POST',
        url: `${BOOKS_BASE_URL}/latest`,
        data: query
    });
};

export {
    searchSimple,
    search,
    getCovers,
    getNewBookRecommend,
    getRecommend,
    getBookDetail,
    getClasses,
    browse,
    getLatest
};
